import { CmsStatusEnum } from "dash-common";
import { BadgeTypes } from "dash-ui";

export interface CmsStatusDropdownProps {
  propertyId: string;
  currentStatus?: CmsStatusEnum | null;
  onStatusChange?: () => void;
}

// Map CMS status to badge types for consistent styling
export const STATUS_TO_BADGE_TYPE: Record<CmsStatusEnum, BadgeTypes> = {
  [CmsStatusEnum.PROPOSED]: "neutral",
  [CmsStatusEnum.DRAFT]: "neutral",
  [CmsStatusEnum.PENDING_APPROVAL]: "warning",
  [CmsStatusEnum.NEW_LISTING]: "active",
  [CmsStatusEnum.ACTIVE_LISTING]: "active",
  [CmsStatusEnum.AWAITING_AUDIT]: "warning",
  [CmsStatusEnum.RECENTLY_UPDATED]: "active",
  [CmsStatusEnum.PENDING_ARCHIVE]: "warning",
  [CmsStatusEnum.ARCHIVED]: "alert",
};

// UI Constants
export const DROPDOWN_WIDTH = 160;
export const BADGE_HEIGHT = 32;

// Default fallback messages
export const DEFAULT_MESSAGES = {
  notSet: "Not Set",
  updateSuccess: "Status updated successfully",
  updateError: "Failed to update status",
};